import { createSelector } from 'reselect'

const  questionnaireTextFileResultConnectionSelector = state => state.questionnaireTextFileResultConnection

export const answerResultModalLoading = createSelector(
    [questionnaireTextFileResultConnectionSelector],
    (questionnaireTextFileResultConnection)=> questionnaireTextFileResultConnection.meta.fetch
)
